<template>
  <div
    v-if="data"
    class="membership-page"
  >
    <div class="membership-header">
      <button
        type="button"
        class="nav-btn"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <div class="page-title">
        {{ $t('vipPage.title') }}
      </div>
      <button
        type="button"
        class="nav-btn"
        @click="$router.push('/grap')"
      >
        <!--   <van-icon
          name="bars"
          size="22"
        /> -->
      </button>
    </div>

    <main class="membership-content">
      <!--  <h1 class="level-title">
        {{ $t('vipPage.levelTitle') }}
      </h1> -->

      <section class="vip-list">
        <button
          v-for="item in levelCards"
          :key="item.key"
          type="button"
          class="vip-card"
          :class="[item.cardClass, { 'is-current': item.isCurrent }]"
          @click="goUpgrade(item)"
        >
          <div class="vip-logo-box">
            <img
              v-if="item.image"
              :src="item.image"
              alt=""
              class="vip-logo-img"
              @error="hideBrokenImage"
            >
            <span class="vip-logo-text">{{ $t('vipPage.vipMark') }}</span>
          </div>

          <div class="vip-card-copy">
            <div class="vip-card-name">
              {{ item.name }}
            </div>
            <div class="vip-card-desc">
              <p
                v-for="line in item.lines"
                :key="line"
              >
                {{ line }}
              </p>
            </div>
          </div>

          <div
            v-if="item.isCurrent"
            class="current-badge"
          >
            {{ $t('vipPage.currentLevel') }}
          </div>
        </button>

        <!--      <div class="vip-card date-card">
          <div class="vip-logo-box">
            <span class="vip-logo-text">{{ $t('vipPage.vipMark') }}</span>
          </div>
          <div class="vip-card-copy">
            <div class="vip-card-name">
              {{ $t('vipPage.dateCard') }}
            </div>
            <div class="vip-card-desc state-desc">
              {{ $t('vipPage.stateNotActivated') }}
            </div>
          </div>
        </div> -->
      </section>
    </main>
  </div>
</template>

<script>
import Vue from 'vue';
import { Icon } from 'vant';
import Fetch from '../../utils/fetch';

Vue.use(Icon);

export default {
  name: 'Vip',
  data() {
    return {
      data: null,
      vips: [],
      colorClasses: [
        'card-steel',
        'card-orange',
        'card-indigo',
        'card-blue'
      ]
    };
  },
  computed: {
    levelCards() {
      const cards = [
        // {
        //   key: 'normal',
        //   name: this.$t('vipPage.normalLevel'),
        //   lines: [this.$t('vipPage.freeBenefits')],
        //   cardClass: 'card-normal',
        //   image: '',
        //   isCurrent: this.isNormalCurrent()
        // }
      ];

      (this.vips || []).forEach((item, index) => {
        cards.push({
          key: item.id || `${item.name}-${index}`,
          name: this.getVipName(item, index),
          lines: this.getVipLines(item, index),
          cardClass: this.colorClasses[index % this.colorClasses.length],
          image: this.getVipImage(item),
          isCurrent: this.isCurrentLevel(item)
        });
      });

      return cards;
    }
  },
  created() {
    this.$parent.footer('item', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/user/basicinfo').then((r) => {
        this.data = r.data || {};
        this.vips = this.data.vips || [];
      });
    },
    goUpgrade(item) {
      if (!item || item.key === 'normal') {
        return;
      }
      this.$router.push('/invest');
    },
    getVipName(item, index) {
      if (item && item.name) {
        const name = String(item.name).trim();
        const match = name.match(/^vip\s*(\d+)?$/i);
        if (match) {
          return `VIP${match[1] || this.getVipNo(item, index)}`;
        }
        return name;
      }
      return `VIP${this.getVipNo(item, index)}`;
    },
    getVipLines(item, index) {
      const value = this.formatMoney(item && item.value);
      const rate = this.formatRate(item && item.rate);
      const orderCount = this.getOrderCount(item, index);

      return [
        `${this.$t('vipPage.requiredInvestment')} ${this.moneyMark()}${value}`,
        `${this.$t('vipPage.commission')} ${rate}% | ${orderCount} ${this.$t('vipPage.order')}`
      ];
    },
    getVipImage(item) {
      if (item && item.imgh) {
        return item.imgh;
      }
      if (item && item.img) {
        return item.img;
      }
      return '';
    },
    getVipNo(item, index) {
      const no = Number(item && item.no);
      if (no > 0) {
        return no;
      }
      return index + 1;
    },
    getOrderCount(item, index) {
      const orderCount = Number(item && (item.onum || item.order || item.orders));
      if (orderCount > 0) {
        return orderCount;
      }
      return this.getVipNo(item, index) * 10;
    },
    isCurrentLevel(item) {
      const current = this.data && this.data.vip;
      if (!item || !current) {
        return false;
      }

      if (current.id && item.id && Number(current.id) === Number(item.id)) {
        return true;
      }

      if (current.name && item.name && current.name === item.name) {
        return true;
      }

      if (this.data.vip_name && item.name && this.data.vip_name === item.name) {
        return true;
      }

      if (current.no && item.no && Number(current.no) === Number(item.no)) {
        return true;
      }

      return false;
    },
    isNormalCurrent() {
      if (!this.data) {
        return false;
      }

      if (!this.data.vip && !this.data.vip_name) {
        return true;
      }

      return Number(this.data.baoku_money || 0) <= 0 && !this.isAnyVipCurrent();
    },
    isAnyVipCurrent() {
      return (this.vips || []).some((item) => this.isCurrentLevel(item));
    },
    moneyMark() {
      if (typeof this.utils_moneyMark === 'function') {
        return this.utils_moneyMark();
      }
      return localStorage.getItem('moneyMark') || '$';
    },
    formatMoney(value) {
      const numberValue = Number(value);
      if (!Number.isFinite(numberValue)) {
        return '0.00';
      }
      return numberValue.toFixed(2);
    },
    formatRate(value) {
      const numberValue = Number(value);
      if (!Number.isFinite(numberValue)) {
        return '0.00';
      }
      return numberValue.toFixed(2);
    },
    hideBrokenImage(event) {
      event.target.style.display = 'none';
    }
  }
};
</script>

<style lang="less" scoped>
.membership-page {
  min-height: 100vh;
  background: #fff;
  color: #16223a;
  padding-bottom: 80px;
  box-sizing: border-box;
}

.membership-header {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  border-bottom: 1px solid rgba(240, 242, 245, 1);
  background: #fff;
  box-sizing: border-box;
}

.nav-btn {
  width: 30px;
  height: 30px;
  border: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 93, 122, 0.12);
  color: #ff5d7a;
  font-size: 18px;
  line-height: 30px;
  box-sizing: border-box;
}

.nav-btn:empty {
  pointer-events: auto;
  opacity: 0;
}

.page-title {
  max-width: 72%;
  color: #16223a;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.membership-content {
  padding: 16px 16px 0;
}

.level-title {
  margin: 0 0 20px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
}

.vip-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.vip-card {
  width: 100%;
  min-height: 118px;
  position: relative;
  display: grid;
  grid-template-columns: 78px minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  padding: 18px 16px;
  border: 1px solid rgba(255, 93, 122, 0.16);
  border-radius: 14px;
  overflow: hidden;
  text-align: left;
  color: #16223a;
  background-color: #fff;
  background-image: url('../images/ban5/vip-bg.png');
  background-repeat: no-repeat;
  background-position: center right 18px;
  background-size: 170px auto;
  box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
  box-sizing: border-box;
}

.vip-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(35, 35, 35, 0.92) 0%, rgba(41, 41, 41, 0.74) 60%, rgba(41, 41, 41, 0.38) 100%);
  pointer-events: none;
}

.vip-card::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: var(--vip-accent, #ff5d7a);
  opacity: 0.78;
}

.vip-logo-box {
  width: 72px;
  height: 72px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid rgba(255, 93, 122, 0.28);
  // background: #16223a;
  color: #16223a;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.24);
  z-index: 1;
}

.vip-logo-text {
  position: absolute;
  top: 25px;
  left: 0;
  right: 0;
  color: #ff7791;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
}

.vip-logo-img {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  object-fit: cover;
}

.vip-card-copy {
  min-width: 0;
  position: relative;
  z-index: 1;
}

.vip-card-name {
  margin-bottom: 8px;
  color: #ff5d7a;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.vip-card-desc {
  color: #d7d0c8;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
}

.vip-card-desc p {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.vip-card-desc p + p {
  font-size: 12px;
}

.state-desc {
  color: rgba(255, 255, 255, 0.74);
  font-size: 14px;
  font-style: italic;
}

.current-badge {
  min-width: 88px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  border: 1px solid rgba(255, 93, 122, 0.42);
  border-radius: 14px;
  color: #ff5d7a;
  background: rgba(255, 93, 122, 0.12);
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  white-space: nowrap;
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}

.card-normal {
  --vip-accent: #6d7688;
}

.card-steel {
  --vip-accent: #8f775f;
}

.card-blue {
  --vip-accent: #ff5d7a;
}

.card-orange {
  --vip-accent: #e89b55;
}

.card-indigo {
  --vip-accent: #8d83d8;
}

.date-card {
  --vip-accent: #3fa384;
}

@media (max-width: 360px) {
  .membership-content {
    padding-right: 12px;
    padding-left: 12px;
  }

  .vip-card {
    grid-template-columns: 66px minmax(0, 1fr);
    gap: 12px;
    padding-right: 14px;
    padding-left: 14px;
  }

  .vip-logo-box {
    width: 62px;
    height: 62px;
  }

  .current-badge {
    min-width: 78px;
    height: 26px;
    font-size: 12px;
  }
}
</style>
